// extracted by mini-css-extract-plugin
export default {"map-loading":"fl_T7K","map-skeleton":"WNwaZu"};